<template>
  <div class="Admin">
    <admin-sidebar></admin-sidebar>
    <a class="float-sm-left" href="https://github.com/CHIMEFRB/frb-web/blob/master/src/components/Admin/admin.vue" target="_blank" style="color:black">
      <b-icon icon="github" aria-hidden="true" font-scale="1.0"></b-icon>
    </a>
    <div class="text-center" id="welcome">
    </div>
    <h4>Overview</h4>
    <b-row>
      <b-col md="12">
      <b-tabs content-class="mt-3">
        <b-tab title="Roles" active>
          <b-row>
      <b-col md="4">
        <img src="https://frb.chimenet.ca/CHIME_FRB_Operations_Management_Structure.svg" width='500px'>
      </b-col>
      <b-col md="4">
        <b-table show-empty
          :items="roleItems['projectOffice']"
          :fields="teamFields"
          :small="smallTable"
        >
        </b-table>
      </b-col>
      <b-col md="4">
        <b-table show-empty
          :items="roleItems['frbCoordinator']"
          :fields="teamFields"
          :small="smallTable"
        >
        </b-table>
      </b-col>
      </b-row>
      <b-tabs vertical v-model="tabIndex" card pills>
      <b-tab title="System Roles">
      <b-row>
      <b-col md="3">
        <b-table show-empty
          :items="roleItems['systempipelineExperts']"
          :fields="teamFields"
          :small="smallTable"
        >
        </b-table>
      </b-col>
      <b-col md="3">
        <b-table show-empty
          :items="roleItems['frbAdmin']"
          :fields="teamFields"
          :small="smallTable"
        >
        </b-table>
      </b-col>
      <b-col md="3">
        <b-table show-empty
          :items="roleItems['frbApprentice']"
          :fields="teamFields"
          :small="smallTable"
        >
        </b-table>
      </b-col>
      <b-col md="3">
        <b-table show-empty
          :items="roleItems['systemTsars']"
          :fields="teamFields"
          :small="smallTable"
        >
        </b-table>
      </b-col>
      </b-row>
      </b-tab>
      <b-tab title="Science Roles">
      <b-row>
      <b-col md="4">
        <b-table show-empty
          :items="roleItems['sciencepipelineExperts']"
          :fields="teamFields"
          :small="smallTable"
        >
        </b-table>
      </b-col>
      <b-col md="4">
        <b-table show-empty
          :items="roleItems['dataqualityExperts']"
          :fields="teamFields"
          :small="smallTable"
        >
        </b-table>
      </b-col>
      <b-col md="4">
        <b-table show-empty
          :items="roleItems['teamLeaders']"
          :fields="teamFields"
          :small="smallTable"
        >
        </b-table>
      </b-col>
      <b-col md="4">
        <b-table show-empty
          :items="roleItems['members']"
          :fields="teamFields"
          :small="smallTable"
        >
        </b-table>
      </b-col>
      </b-row>
      </b-tab>
      </b-tabs>
      </b-tab>
      <b-tab title="Teams">
          <b-row>
          <b-col md="3">
            <h5 style="float:center">Team 1</h5>
            <b-table show-empty
              :items="teamItems['1']"
              :fields="teamFields"
              :small="smallTable"
              :headerTitle="Team1"
            >
            </b-table>
          </b-col>
          <b-col md="3">
            <h5 style="float:center">Team 2</h5>
            <b-table show-empty
              :items="teamItems['2']"
              :fields="teamFields"
              :small="smallTable"
              :headerTitle="Team2"
            >
            </b-table>
          </b-col>
          <b-col md="3">
            <h5 style="float:center">Team 3</h5>
            <b-table show-empty
              :items="teamItems['3']"
              :fields="teamFields"
              :small="smallTable"
              :headerTitle="Team3"
            >
            </b-table>
          </b-col>
          <b-col md="3">
            <h5 style="float:center">Team 4</h5>
            <b-table show-empty
              :items="teamItems['4']"
              :fields="teamFields"
              :small="smallTable"
              :headerTitle="Team4"
            >
            </b-table>
          </b-col>
          </b-row>
        </b-tab>
      <b-tab title="Personnel Analysis Summary" v-if="userRole==='PROJECT OFFICE' || userRole==='FRB COORDINATOR' || userRole==='TEAM LEADER'">
        <b-row>
          <b-col md="4" class="my-1">
            <b-form-group horizontal label="Filter" class="mb-0">
              <b-input-group>
                <b-form-input v-model="tableFilter" placeholder="Type to Search" />
                <b-input-group-append>
                  <b-btn :disabled="!tableFilter" @click="tableFilter = ''">Clear</b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col md="4" class="my-1">
          <b-form-group horizontal label="Per page" class="mb-0">
            <b-form-select :options="pageOptions" v-model="perPage" />
          </b-form-group>
          </b-col>
          <b-col md="4" class="my-1">
            <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
          </b-col>
        </b-row>

          <b-table show-empty
            :items="analysisSummaryItems"
            :fields="analysisSummaryFields"
            :small="smallTable"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="tableFilter"
            @filtered="onFiltered"
          >
          </b-table>
      </b-tab>
      <b-tab title="Manage" v-if="userRole==='PROJECT OFFICE' || userRole==='FRB COORDINATOR'">
          <b-form @submit="onSubmit" @reset="onReset">
          <b-form-group id="input-group-1">
            <b-form-checkbox-group v-model="form.checked" id="checkboxes-4">
              <b-form-checkbox value="team">Change Team</b-form-checkbox>
              <b-form-checkbox value="role">Change Role</b-form-checkbox>
            </b-form-checkbox-group>
          </b-form-group>
          <b-form-group
            id="user"
            label="Select User:"
            label-for="username"
            description="Do not forget to select the change you are trying to make"
          >
            <b-form-select
              id="username"
              v-model="form.name"
              required
              :options="form.options"
              ></b-form-select>
          </b-form-group>
          <b-form-group id="input-group-2" label="Select Team:" label-for="input-2"
              v-if="form.name && form.checked.includes('team')">
            <b-form-select
              id="input-2"
              v-model="form.team"
              :options="teams"
              required
            ></b-form-select>
          </b-form-group>
          <b-form-group id="input-group-3" label="Select Role:" label-for="input-3"
              v-if="form.name && form.checked.includes('role')">
            <b-form-select
              id="input-3"
              v-model="form.role"
              :options="roles"
              required
            ></b-form-select>
          </b-form-group>
          <b-card header="Making the following change:" v-if="form.name && form.checked.length>0 && (form.team || form.role)">
            <p v-if="form.name"> User: <b>{{form.name}}</b>
            <span v-if="form.team">, new team is: <b>{{form.team}}</b></span>
            <span v-if="form.role">, new role is: <b>{{form.role}}</b></span>
            </p>
            <b>Validate the above information before submitting.</b>
          </b-card>

          <b-button type="submit" variant="primary" v-if="form.name && form.checked.length>0 && (form.team || form.role)">Submit</b-button>
          <b-button type="reset" variant="danger" v-if="form.name && form.checked.length>0 && (form.team || form.role)">Reset</b-button>
          </b-form>
          <b-card style="color:red">
            {{submitStatus}}
          </b-card>
        </b-tab>
      </b-tabs>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import adminSidebar from './adminSidebar'
import { AdminMixin } from '../mixins/adminMixin.js'
// var baseUrl = 'https://frb.chimenet.ca/frb-master/'
export default {
  mixins: [AdminMixin],
  data () {
    return {
      teamItems: {'1': [], '2': [], '3': [], '4': []},
      roleItems: {'projectOffice': [], 'frbCoordinator': [], 'teamLeaders': [], 'systempipelineExperts': [], 'members': [], 'sciencepipelineExperts': [], 'dataqualityExperts': [], 'systemTsars': []},
      teamFields: [],
      roleFields: [],
      analysisSummaryFields: [
        {key: 'user', sortable: true, label: 'User', 'class': 'text-left'},
        {key: 'intensity-dm-pipeline', sortable: true, label: 'Intensity DM Pipeline', 'class': 'text-left'},
        {key: 'intensity-fitburst', sortable: true, label: 'Fitburst', 'class': 'text-left'},
        {key: 'intensity-calibration', sortable: true, label: 'Intensity Calibration', 'class': 'text-left'},
        {key: 'header-localization', sortable: true, label: 'Header Loc', 'class': 'text-left'},
        {key: 'intensity-localization', sortable: true, label: 'Intensity Loc', 'class': 'text-left'},
        {key: 'baseband', sortable: true, label: 'Baseband', 'class': 'text-left'}
      ],
      analysisSummaryItems: [],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      // totalRows: analysisSummaryItems.length,
      tableFilter: null,
      pageOptions: [ 5, 10, 15, 50, 100 ],
      userRole: 'MEMBER',
      userTeam: '',
      form: {
        name: '',
        team: null,
        role: null,
        options: [{ value: null, text: 'Please select an option' }],
        checked: []
      },
      teams: [{ text: 'Select One', value: null }, '1', '2', '3', '4', 'N/A'],
      roles: [{ text: 'Select One', value: null }, 'PROJECT OFFICE', 'FRB COORDINATOR', 'SYSTEM PIPELINE EXPERT', 'FRB ADMIN', 'FRB APPRENTICE', 'SCIENCE PIPELINE EXPERT', 'TEAM LEADER', 'MEMBER', 'DATA QUALITY EXPERT', 'SYSTEM TSAR'],
      submitStatus: null,
      baseUrl: 'https://frb.chimenet.ca/frb-master/'
      // baseUrl: 'http://localhost:8001'
    }
  },
  mounted () {
    this.userName = localStorage.username
    this.refreshToken()
    var authHeaders = {'Authorization': localStorage.accessToken}
    this.$http.get(this.baseUrl + '/v1/admin/role/' + localStorage.username, {headers: authHeaders}, {responseType: 'json', timeout: 10000})
      .then(response => {
        this.getUserRole(response.body)
        this.$http.get(this.baseUrl + '/v1/admin/team/' + localStorage.username, {headers: authHeaders}, {responseType: 'json', timeout: 10000})
          .then(response => {
            this.userTeam = response.body
          })
      })
    this.getUsers()
    this.getAnalysisEvents()
  },
  methods: {
    onSubmit (evt) {
      evt.preventDefault()
      var payload = {'sender_role': this.userRole, 'name': this.form.name}
      var toChange = 'team'
      if (this.form.team) {
        payload['team'] = this.form.team
        toChange = 'team'
        this.submitChange(payload, toChange)
      }
      if (this.form.role) {
        payload['role'] = this.form.role
        toChange = 'role'
        this.submitChange(payload, toChange)
      }
    },
    submitChange (payload, toChange) {
      this.refreshToken()
      var authHeaders = {'Authorization': localStorage.accessToken}
      this.$http.post(this.baseUrl + '/v1/admin/assign-' + toChange, payload, {headers: authHeaders}, {responseType: 'json', timeout: 10000})
        .then(response => {
          this.submitStatus = 'Change for ' + payload['name'] + ' was successful!'
          this.getUsers()
          this.form.name = ''
          this.form.team = null
          this.form.role = null
          this.form.checked = []
        }, response => {
          this.submitStatus = 'ERROR!!!!!!! Change for ' + payload['name'] + ' was not successful!'
        })
    },
    onReset (evt) {
      evt.preventDefault()
      // Reset our form values
      this.form.name = ''
      this.form.team = null
      this.form.role = null
      this.form.checked = []
      this.form.options = [{ value: null, text: 'Please select an option' }]
    }
  },
  components: {
    'admin-sidebar': adminSidebar
  }
}

</script>



// WEBPACK FOOTER //
// src/components/Admin/Admin.vue